import { ReactNode, useCallback, useState } from 'react';
import classes from 'classnames';
import { useTranslation } from 'react-i18next';
import { IconElement } from '../../types/IconElement';
import AccordionItem from './AccordionItem';
import styles from './Accordion.module.scss';

export type Props = {
  items: Array<{
    title: string;
    icon?: IconElement;
    content: string | ReactNode;
  }>;
  dataTest?: string;
  className?: string;
  isDividerIncluded?: boolean;
  titleClassName?: string;
};

export default function Accordion({
  items,
  dataTest,
  className,
  isDividerIncluded = true,
  titleClassName,
}: Props) {
  const { t } = useTranslation('common');
  const [openTab, setOpenTab] = useState('');

  const toggleTab = useCallback((tab: string) => {
    setOpenTab((prev) => (prev === tab ? '' : tab));
  }, []);

  return (
    <div data-test={dataTest} className={classes(styles.accordion, className)}>
      {items?.map((item, i) => (
        <div className={styles.tab} key={item.title}>
          {i > 0 && isDividerIncluded && (
            <div className={styles.divider}>{t('or')}</div>
          )}
          <AccordionItem
            titleClassName={titleClassName}
            title={item.title}
            Icon={item.icon}
            onClick={() => toggleTab(item.title)}
            active={openTab === item.title}
          >
            {item.content}
          </AccordionItem>
        </div>
      ))}
    </div>
  );
}
